import { I18nLocalesEnum } from '@zaoblako/shared/common/enums/i18n.locales.enum';
import { AccessCardTypeEnum } from '@zaoblako/shared/modules/pacs/enums/access-card-type.enum';
import type { EnumI18nInterface } from '@zaoblako/shared/common/interfaces/enum.i18n.interface';

/** Localized human-readable string representations of {@link AccessCardTypeEnum} enumeration values */
export const AccessCardTypeEnumI18n: EnumI18nInterface<AccessCardTypeEnum> = {
  [I18nLocalesEnum.RU_RU]: {
    [AccessCardTypeEnum.TEST_MOCK_CARD]: 'Протокол "Тестовый"',
    [AccessCardTypeEnum.EM_MARINE]: 'Протокол "EM-Marine"',
    [AccessCardTypeEnum.MIFARE]: 'Протокол "Mifare"',
  },
  [I18nLocalesEnum.EN_US]: {
    [AccessCardTypeEnum.TEST_MOCK_CARD]: '"Test" protocol',
    [AccessCardTypeEnum.EM_MARINE]: '"EM-Marine" protocol',
    [AccessCardTypeEnum.MIFARE]: '"Mifare" protocol',
  },
};
